import styles from './PropertySpyNotification.module.css'
import { useState } from 'react';
import { DateTime } from 'luxon';
import { useEffect } from 'react';
import { Link } from 'react-router-dom';

type PropertySpyNotificationProps = {
    notificationLog: any,
    loading?: boolean,
}

export const PropertySpyNotification = (props: PropertySpyNotificationProps): JSX.Element => {
    const {
        notificationLog,
        loading = false
    } = props;
    const [notification, setNotification] = useState<any | null>(null);

    useEffect(() => {
        if (notificationLog === undefined) {
            return;
        }

        const data: any = JSON.parse(notificationLog.data);
        const message = `${data.HostName} changed`;

        const notification = {
            title: `Property Alert!`,
            date: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('M/dd/yyyy'),
            time: DateTime.fromISO(notificationLog.dateTimeUtc).toFormat('hh:mm a'),
            message: message,
            data: data,
        }

        setNotification(notification);
    }, [notificationLog]);

    if (notification === null) {
        return (<></>);
    }

    return (
        <Link
            className={styles.PropertySpyNotification__Link}
            to={`/propertyspy/${notification.data.PropId}`}>
            <div className={styles.PropertySpyNotification}>
                <div
                    className={styles.PropertySpyNotification__Header}
                >
                    <div className={styles.PropertySpyNotification__Heading1}>
                        {notification.title}
                    </div>
                    <div className={styles.PropertySpyNotification__DateTimeContainer}>
                        <div className={styles.PropertySpyNotification__Date}>
                            {notification.date}
                        </div>
                        <div className={styles.PropertySpyNotification__Time}>
                            {notification.time}
                        </div>
                    </div>
                </div>
                <hr className={styles.PropertySpyNotification__HeaderDivider}></hr>
                <div>
                    <div className={styles.PropertySpyNotification__Message}>
                        {notification.message}
                    </div>
                </div>
                <div className={styles.PropertySpyNotification__SeeMoreContainer}>
                    <div className={styles.PropertySpyNotification__SeeMore}>
                        See more
                    </div>
                </div>
            </div>
        </Link>
    )
}
